import { IBookingCalendarStore } from '../../index'
import { IToggleDeleteReservationModal } from '../../../../actions/bookingCalendar/reservationModal/toggleDeleteReservationModal'

export default function(
  store: IBookingCalendarStore,
  action: IToggleDeleteReservationModal,
): IBookingCalendarStore {
  return {
    ...store,
    deleteReservationModal: {
      ...store.deleteReservationModal,
      id: action.toggle
        ? action.id
          ? action.id
          : store.deleteReservationModal.id
        : null,
      isOpen: action.toggle,
    },
  }
}
